import { RuntimeConfig, setRuntimeConfig } from "./types"

export class ConfigLoadError extends Error {
  constructor(
    message: string,
    public cause?: unknown
  ) {
    super(message)
    this.name = "ConfigLoadError"
  }
}

function validateConfig(data: unknown): RuntimeConfig {
  if (!data || typeof data !== "object") {
    throw new ConfigLoadError("Config must be an object")
  }

  const config = data as Record<string, unknown>

  if (config.env !== "staging" && config.env !== "prod") {
    throw new ConfigLoadError('Config.env must be "staging" or "prod"')
  }

  if (typeof config.apiBaseUrl !== "string" || !config.apiBaseUrl) {
    throw new ConfigLoadError("Config.apiBaseUrl must be a non-empty string")
  }

  if (
    typeof config.tonConnectManifestUrl !== "string" ||
    !config.tonConnectManifestUrl
  ) {
    throw new ConfigLoadError(
      "Config.tonConnectManifestUrl must be a non-empty string"
    )
  }

  return {
    env: config.env,
    apiBaseUrl: config.apiBaseUrl,
    tonConnectManifestUrl: config.tonConnectManifestUrl,
    centrifugoUrl:
      typeof config.centrifugoUrl === "string"
        ? config.centrifugoUrl
        : undefined,
    pvpRoomId:
      typeof config.pvpRoomId === "string" ? config.pvpRoomId : "default",
    sentryDsn: typeof config.sentryDsn === "string" ? config.sentryDsn : null,
    giftRelayBotHandle:
      typeof config.giftRelayBotHandle === "string"
        ? config.giftRelayBotHandle
        : null,
  }
}

export async function loadConfig(): Promise<RuntimeConfig> {
  try {
    const response = await fetch("/config.json", { cache: "no-store" })

    if (!response.ok) {
      throw new ConfigLoadError(
        `Failed to fetch config: ${response.status} ${response.statusText}`
      )
    }

    const data = await response.json()
    const config = validateConfig(data)

    setRuntimeConfig(config)
    console.log(`[Config] Loaded for env: ${config.env}`)

    return config
  } catch (error) {
    if (error instanceof ConfigLoadError) {
      throw error
    }
    throw new ConfigLoadError("Failed to load config", error)
  }
}
